<template>

    <b-button v-if="$sessionsStorage.get('designation') == 'Admin' &&
        $sessionsStorage.get('nameUser') == 'Bhavneesh'" style="font-size: 0.675rem" class="mt-2" size="sm" @click="resetJobDetails()" :variant="'danger'">
        Reset Sline Flow
    </b-button>

</template>

<script>
import NodeLockPannelService from "../../services/NodeLockPannelService";
export default {
    props: {
        allModuleId: { type: Number, default: null },
        JobNo: { type: String, default: null },
    },
    beforeMount() {

    },
    data() {
        return {
            JobAssNo: this.JobNo,
            JobId: this.allModuleId,
            alert: {
                content: "Added Succesfully",
                ok: "ok",
            },
        };
    },
    components: {

    },
    computed: {

    },
    created() {

    },
    methods: {

        resetJobDetails() {
           
            // Validate and save the updated data
            if (this.JobId && this.JobId > 0) {

                console.log("Updated Row Data:", this.JobId);

                // Optional: Call an API to save the changes to the backend
                NodeLockPannelService.resetSlineSubscriptionFlow({ JobId: this.JobId,JobNo:this.JobAssNo })
                    .then(response => {
                        const { data, status, statusText } = response;
                        console.log("Update successful:", response.data);
                        this.alert.content = data.message;
                        this.$emit('refresh-data', this.localData);
                    })
                    .catch(error => {
                        console.error("Update failed:", error);
                    });
            } else {
                console.error("Please fill out all required fields.");
            }
        },
    }
};
</script>


// WEBPACK FOOTER //
// ResetSlineSubscription.vue?123d5f40